/** 레거시 `getRateValue` — 수수료율을 API 소수(0~1)로 변환 */
export const toCommissionRateDecimal = (value: string | number): number => {
  if (typeof value === 'number') {
    if (value > 1) return Number((value / 100).toFixed(4));
    if (value < 0 || value > 1)
      throw new Error('standard_commission_rate_error');
    return Number(value.toFixed(4));
  }

  const trimmed = value.trim();
  if (/^(\d+(\.\d+)?)%$/.test(trimmed)) {
    return Number((Number(trimmed.replace('%', '')) / 100).toFixed(4));
  }

  const numeric = Number(trimmed);
  if (Number.isNaN(numeric)) throw new Error('standard_commission_rate_error');
  if (numeric > 1) return Number((numeric / 100).toFixed(4));
  if (numeric < 0 || numeric > 1)
    throw new Error('standard_commission_rate_error');
  return Number(numeric.toFixed(4));
};

/** API 소수(0~1) 또는 이미 %인 값을 퍼센트 수치로 변환 */
export const toCommissionRatePercent = (
  rate?: number | null,
): number | null => {
  if (rate == null) return null;
  return rate > 1 ? rate : rate * 100;
};

/** 정수면 그대로, 소수면 소수점 2자리 (부동소수 오차는 2자리로 정규화) */
export const formatCommissionRatePercentText = (percent: number): string => {
  const normalized = Number(percent.toFixed(2));
  return Number.isInteger(normalized)
    ? String(normalized)
    : normalized.toFixed(2);
};

/** 상세 입력 필드용 — 소수(0.125) → "12.50", 정수(0.1) → "10" */
export const formatCommissionRateInput = (rate?: number): string => {
  const percent = toCommissionRatePercent(rate);
  if (percent == null) return '';
  return formatCommissionRatePercentText(percent);
};

/** 목록 표시용 — 소수(0.125) → "12.50%", 정수 → "10%" */
export const formatCommissionRateDisplay = (rate?: number | null): string => {
  const percent = toCommissionRatePercent(rate);
  if (percent == null) return '-';
  return `${formatCommissionRatePercentText(percent)}%`;
};
